import React, {
  useState, useEffect, useContext
} from 'react'
import RTExports from 'components/Exports/RTExports';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import AdvancedSearchContext from "context/AdvancedSearchContext";
import postPageVisit from "services/LogService";

export default function Exports() {
  const [redirState, setRedirState] = useState(false);
  const appContext = useContext(AdvancedSearchContext);
  const { setPage } = appContext;

  useEffect(() => {
    setPage('exports');
    postPageVisit('exports');
  }, []);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/exports",
      }}
    />
  );
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"exports"}
    >
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <RTExports />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {redirecting}
    </ErrorBoundary>
  )
}
